import { Model } from '@vuex-orm/core';

export default class BaseModel extends Model {
  static entity = 'base_model';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.string(''),
      createdAt: this.attr('date'),
      updatedAt: this.attr('date'),
      selfUrl: this.string(''),
      updateUrl: this.string(''),
      deleteUrl: this.string('')
    };
  }

  get canRefresh() {
    return this.selfUrl.length > 0;
  }

  get canUpdate() {
    return this.updateUrl.length > 0;
  }

  get canDelete() {
    return this.deleteUrl.length > 0;
  }
}
